import React from 'react'

export default function SignUp() {
    return (
        <div>
            <h1>SignUp</h1>
        </div>
    )
}
